import type * as React from 'react';
import { SuccessNotification } from '@verclam/toast-v2';

/**
 * Kept separate from `AuthenticationNotifications`, which is shared by three screens that can never
 * dispatch `PASSWORD_RESET_PERFORMED`: an inert listener there would be a toast surprise waiting for
 * the day one of those actions gets reused elsewhere.
 */
const PasswordResetNotifications: React.FC = () => {
	return (
		<SuccessNotification
			eventName="PASSWORD_RESET_PERFORMED"
			title="Mot de passe réinitialisé"
			message="Votre mot de passe a été réinitialisé."
		/>
	);
};

export default PasswordResetNotifications;
